<div class="page-content page-fill">
  <div class="card mb-3">
    <div class="card-body">
      <div class="m-3">
        <h2>Login</h2>
      </div>
      @if (filter) {
        <dx-form [formData]="filter" style="max-width: 500px">
          <dxi-item dataField="email" [label]="{ text: 'Email Address' }"></dxi-item>
          <dxi-item dataField="userCode" [label]="{ text: 'User Code' }"></dxi-item>
        </dx-form>
      }
      <button (click)="loginMember()" class="mt-3 ms-4 btn btn-primary" [disabled]="processing">Log In</button>
      <div class="mt-3"><span>Don't have your code anymore?  Forgot password?  Use "Get User Code" below</span></div>
    </div>
    <div class="card-body">
      <div class="m-3">
        <h2>Get User Code</h2>
      </div>
      @if (codeFilter) {
        <dx-form [formData]="codeFilter" style="max-width: 500px" validationGroup="mainValidation" >
          <!-- <dxi-item dataField="budgetBox" [label]="{ text: 'Budget Envelope' }">
          <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
        </dxi-item> -->
        <dxi-item dataField="email" [label]="{ text: 'Email Address' }">
          <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="birthDate" [label]="{ text: 'Birth Date (format MM/DD/YYYY)' }" editorType="dxDateBox" [editorOptions]="{valueChangeEvent: 'focusout'}" >
          <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
          <dxi-validation-rule type="custom" message="Date must be in format MM/DD/YYYY" [validationCallback]="validateDateFormat" [reevaluate]="true"></dxi-validation-rule>
        </dxi-item>
        <!-- <dxi-item [label]="{ text: 'Birth Date (format MM/DD/YYYY)' }">
        <div *dxTemplate>
          <dx-date-box [(value)]="codeFilter.birthDate" valueChangeEvent="foucusOut"> </dx-date-box>
        </div>
      </dxi-item> -->
    </dx-form>
  }
  <button (click)="getCode()" class="mt-3 ms-4 btn btn-primary" [disabled]="processing">Get User Code</button>
</div>
</div>
</div>
